import "../../../design/footer.css";
import { FaFacebook, FaYoutube, FaCcVisa, FaCcMastercard, FaCcAmex, FaPaypal, FaLink, FaBookOpen, FaHandshake, FaHeart } from "react-icons/fa";
import { Container } from "react-bootstrap";
import Developer from "./footer/Developer";
import { WEBSITE_URL } from "../../../api/API_SERVERS";
import logo from "../../../assets/logo.avif";

export default function Footer() {
    const setRandomColors = () => {
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);
        document.documentElement.style.setProperty('--random-r', r);
        document.documentElement.style.setProperty('--random-g', g);
        document.documentElement.style.setProperty('--random-b', b);
    };

    const changeLink = (link) => {
        window.location.assign(`${WEBSITE_URL}/${link}`);
    };

    return (
        <div className={'footerSpace'} id={'footer'}>
            {/* Decorative background elements */}
            <div className="footer-bubble bubble-1"></div>
            <div className="footer-bubble bubble-2"></div>

            <Container>
                <div className={'footerCardSpace'}>

                    {/* Main Links */}
                    <div className={'footerCard section-blue'}>
                        <div className={'footerCardTitle'}>
                            <span className="footerTitleIcon"><FaLink /></span>
                            მთავარი ლინკები
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("about-us")}>
                            ჩვენს შესახებ
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("login")}>
                            ავტორიზაცია
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("register")}>
                            რეგისტრაცია
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("contact-us")}>
                            კონტაქტი
                        </div>
                    </div>

                    {/* Articles */}
                    <div className={'footerCard section-green'}>
                        <div className={'footerCardTitle'}>
                            <span className="footerTitleIcon"><FaBookOpen /></span>
                            სტატიები
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("community-articles")}>
                            სტატიები
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("community-videos")}>
                            სასარგებლო ვიდეოები
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("terms-and-conditions")}>
                            წესები და პირობები
                        </div>
                    </div>

                    {/* Collaboration */}
                    <div className={'footerCard section-orange'}>
                        <div className={'footerCardTitle'}>
                            <span className="footerTitleIcon"><FaHandshake /></span>
                            კოლაბორაცია
                        </div>

                        <div className={'footerCardLinks animated-text'} onMouseOver={setRandomColors}
                             onClick={() => changeLink("cooperate-with-us")}>
                            ითანამშრომლეთ ჩვენთან
                        </div>

                        <div className="payment-wrapper">
                            <div
                                className="payment-btn"
                                onClick={() => window.open('https://www.paypal.com/ncp/payment/ZA5UX95Y864YQ')}
                            >
                                <FaPaypal className="paypal-icon"/>
                                <span className="payment-text">დონაცია</span>
                            </div>

                            <div className="payment-cards">
                                <FaCcVisa/>
                                <FaCcMastercard/>
                                <FaCcAmex/>
                            </div>

                            <div className="payment-note">
                                Secure payments via PayPal
                            </div>
                        </div>
                    </div>

                    {/* About */}
                    <div className={'footerCard section-pink'}>
                        <div className={'footerDescriptionTitle'}>
                            <span className="footerTitleIcon"><FaHeart /></span>
                            ჩვენს შესახებ
                        </div>

                        <div className={'footerDescription'}>
                            ჩვენ შევქმენით ვირტუალური სივრცე, ხიდი 🌉, მშობლებსა 👩‍👦 და მასწავლებლებს 👩‍🏫 შორის.
                            მასწავლებლის სივრცეს უხარია ყოველი ბედნიერი მომხმარებლის წარმატება! 💓
                        </div>

                        <div className={'footerDescriptionIconSpace'}>
                            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"
                               className={'footerDescriptionIcon fb'}>
                                <FaFacebook size={25} />
                            </a>

                            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer"
                               className={'footerDescriptionIcon yt'}>
                                <FaYoutube size={25} />
                            </a>
                        </div>
                    </div>

                </div>

                <div className={'footerCardImageWrapper'}>
                    <img className={'footerCardImage'} src={logo} alt={'logo'}/>
                </div>

                <Developer/>

            </Container>
        </div>
    );
}